<template>
  <div>
    <div class="cardChap">
      <md-card>
        <md-card-header>
          <md-avatar>
            <img :src="author && author.profileImg || defaultProfileImg" alt="Avatar" />
          </md-avatar>

          <md-card-header-text>
            <router-link v-if="author && author.id" tag="div" class="md-title nostyle" :to="{ name: 'profile', params: { id: author.id }}">{{ author.fullName }}</router-link>
            <div v-else class="md-title"><i>Nome</i></div>
            <div class="md-subhead">{{ toDate(chapter.createdAt) || 'Data' }}</div>
          </md-card-header-text>

          <menu-tp
            v-if="user && user.id == chapter.author"
            icon="more_horiz"
            :offsetX="-200"
            :offsetY="-50"
            :items="menu"
            @goTo="linkToChapter"
            @delete="deleteDialog = true"
          />

          <!-- <md-menu md-size="medium" :md-offset-x="-200" :md-offset-y="-50">
            <md-button class="md-icon-button md-list-action" md-menu-trigger>
              <md-icon>more_horiz</md-icon>
            </md-button>

            <md-menu-content>
              <md-button>Editar</md-button>
              <md-button class="listButtonMore">deletar</md-button>
            </md-menu-content>
          </md-menu> -->
        </md-card-header>

        <md-card-media v-if="chapter.media && chapter.media[0]" class="imageCard">
          <media style="padding: 0;" :url="chapter.media[0].url" />
        </md-card-media>

        <md-card-header>
          <div class="md-subhead link">
            <md-icon>location_on</md-icon>
            <router-link v-if="group && group.id" tag="span" class="nostyle" :to="{ name: 'place', params: { id: group.id } }">{{ group.name }}</router-link>
            <span v-else><i>Lugar</i></span>
          </div>
          <h2 class="md-title">{{ chapter.title || "Título" }}</h2>
        </md-card-header>
        <md-card-content v-show="synopsis">{{ synopsis }}</md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" :to="{ name: 'chapter', params: { id: chapter.id }}">
            Ler mais
          </md-button>
        </md-card-actions>
      </md-card>
    </div>

    <md-dialog :md-active.sync="deleteDialog">
      <md-dialog-title>Você tem certeza que deseja deletar esse capítulo?</md-dialog-title>
      <md-dialog-actions>
        <md-button @click="removeChapter()" :disabled="deleteStatus != false">
          <span v-if="!deleteStatus">Sim!</span>
          <loader v-else-if="deleteStatus == 'loading'" />
          <span v-else-if="deleteStatus == 'error'">Erro!</span>
          <span v-else>Deletado!</span>
        </md-button>
        <md-button style="background: lightgrey;" @click="deleteDialog = false">
          Cancelar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import media from "@/components/content/chapter/slide/media";
import menuTp from "@/components/shared/menuTemplate";
import loader from "@/components/shared/loader";
import dateMod from "@/assets/js/date";
import call from "@/api/calls";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: "mediumChapter",
  props: {
    chapter: Object,
    profile: Object,
    place: Object
  },
  components: {
    media,
    menuTp,
    loader
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      group: {},
      author: {},
      menu: [
        {
          text: "Visualizar",
          action: "goTo"
        }, {
          text: "Deletar",
          action: "delete"
        }
      ],
      defaultProfileImg: require('@/assets/avatarDefault.png'),
      deleteDialog: false,
      deleteStatus: false
    };
  },
  created() {
    this.getPlace();
    this.getAuthor();
  },
  computed: {
    synopsis() {
      if(this.chapter.content != null) {
        let index = this.chapter.content.indexOf("\n");
        return index == -1
          ? this.chapter.content
          : this.chapter.content.slice(0, index);
      }
      return '';
    },
  },
  methods: {
    getPlace() {
      if (!this.place && this.chapter.group)
        return call.group.get(this.chapter.group)
        .then(place => (this.group = place))
        .catch(error => log(error, "getPlace()", { place: this.chapter.group }));
      else return this.group = this.place;
    },
    getAuthor() {
      if (!this.profile && this.chapter.author) {
        return call.profile.get(this.chapter.author)
        .then(profile => (this.author = profile))
        .catch(error => log(error, "getAuthor", { author: this.chapter.author }));
      }
      else return this.author = this.profile;
    },
    toDate(date) {
      return dateMod.toDate(new Date(date), "time");
    },
    linkToProfile() {
      let p = this.author;
      if(p && p.id && p.id !== this.$route.params.id)
        return this.$router.push({ name: 'profile', params: { id: p.id }});
    },
    linkToPlace() {
      let p = this.group;
      if(p && p.id && p.id !== this.$route.params.id)
        return this.$router.push({ name: 'place', params: { id: p.id }});
    },
    linkToChapter() {
      if(this.chapter.id)
        return this.$router.push({ name: 'chapter', params: { id: this.chapter.id }});
    },
    removeChapter() {
      this.deleteStatus = "loading";
      call.chapter.remove(this.chapter.id, this.user.id)
      .then(() => {
        this.deleteStatus = true;
        this.$router.go();
      })
      .catch(err => {
        this.deleteStatus = "error";
        log(err, "removeChapter()", null);
      });
    }
  }
};
</script>

<style scoped>
.md-title {
  cursor: pointer;
}

.cardChap {
  padding: 16px;
  word-break: break-word;
}

.imageCard{
  height: 100%;
  /* padding: 1em; */
}

.image{
  max-height: 35vh;
  object-fit: cover;
}

a.nostyle:link {
  text-decoration: inherit;
  color: inherit;
}

a.nostyle:visited {
  text-decoration: inherit;
  color: inherit;
}

.link {
  cursor: pointer;
}

.listButtonMore {
  margin-left: 8px;
}
</style>
